import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MenuComponent } from './menu/menu.component';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { KeylessonResultsDialogComponent } from './dialogs/keylesson-results-dialog/keylesson-results-dialog.component';
import { AdvancedlessonResultsDialogComponent } from './dialogs/advancedlesson-results-dialog/advancedlesson-results-dialog.component';
import { ChartsModule } from 'ng2-charts';
import { ChartComponent } from './chart/chart.component';
import { NgxFlagPickerModule } from 'ngx-flag-picker';
import { ExamResultsDialogComponent } from './dialogs/exam-results-dialog/exam-results-dialog.component';



@NgModule({
  declarations: [MenuComponent, FooterComponent, KeylessonResultsDialogComponent, AdvancedlessonResultsDialogComponent, ChartComponent, ExamResultsDialogComponent],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    RouterModule,
    ChartsModule,
    NgxFlagPickerModule
  ],
  exports: [
    MaterialModule,    
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MenuComponent,
    RouterModule,
    FooterComponent,
    KeylessonResultsDialogComponent, 
    AdvancedlessonResultsDialogComponent,
    ExamResultsDialogComponent,
    ChartsModule,
    ChartComponent,
    NgxFlagPickerModule
  ]
})
export class SharedModule { }
